<template>
      <div class="modal is-active"  >
        <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <!-- <p class="modal-card-title " v-if="mode =='I'" >New Insert Mode </p>
                <p class="modal-card-title " v-if="mode =='U'" >Edit Mode</p> -->
         
            </header>
            <section class="modal-card-body">
                            <div class="container">
                                    <nav class="level is-mobile">
                                        <div class="level-left">

                                        </div>
                                        <div class="level-right">

                                            <div class="level-item">
                                                <b-button type="is-success"  @click="addNewDataRes" icon-right="plus" />
                                            </div>
                                        </div>
                                    </nav>


                                    <b-field  v-for="(dataNew,index) in dataAddNewArr" :key="dataNew.id">
                                        <template #label>
                                            {{index+1}}
                                        </template>
                                        <b-input  v-model = dataNew.val placeholder="Negative" expanded/>
                                        <b-button type="is-danger"  icon-right="delete"  @click="deleteDataNew(dataNew.id)"/>
                                    </b-field>



                                    <!-- <nav class="level is-mobile">
                                        <div class="level-left">

                                        </div>
                                        <div class="level-right">

                                            <div class="level-item">
                                                <b-button type="is-success"
                                                        icon-right="cloud-upload"
                                                        :disabled="dataAddNewArr.length===0"
                                                        @click="saveTemplateResult">
                                                    Save Template Result
                                                </b-button>

                                            </div>
                                        </div>
                                    </nav> -->


                                </div>
               
            </section>
            <footer class="modal-card-foot" style="justify-content: space-between;">
                <b-button type="is-danger"  @click="close">Cancel</b-button>
                <b-button type="is-success"
                        icon-right="cloud-upload"
                        :disabled="dataAddNewArr.length===0"
                        @click="saveTemplateResult">
                    Save Template Result
                </b-button>
            </footer>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import {getBaseURLforBackEnd,getConfigAxios,genUUID}  from '@/utils.js'
import { mapState } from "vuex";


// import {genUUID}  from '@/utils.js'    
export default {
    name : "AddResultBlParasite",
    mounted(){
        // console.log('mount --->  AddResultBlParasite',)
        this.dataAddNewArr.push({"id": genUUID(5) ,"val" :  ""})
        this.dataAddNewArr.push({"id": genUUID(5) ,"val" :  ""})
    },
    computed:{
          ...mapState({
                access_token : state => state.master_data.access_token,
            }) ,
             
    },
    methods:{
       saveTemplateResult(){

                var testFail = false
                var tmpArr = []
                for(var i =0;i<this.dataAddNewArr.length;i++){
                    if(this.dataAddNewArr[i].val === ""){
                        testFail = true
                        break;
                    }else{
                        tmpArr.push(this.dataAddNewArr[i].val)
                    }
                }
                //************************************************
                if(testFail){
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Some data hak blank , please check!',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                }else{
                     const datTo = {
                                      "mode" : 1, // 1 or 2  1 === new insert , 2 === update
                                      "id_edit": null , // id to edit if  update
                                      "dat" : {"id": tmpArr }
                                     }
                    
                    
                    // console.log(JSON.stringify(datTo))
                    
                    
                    const vm = this
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                    axios.post(`${getBaseURLforBackEnd()}/api/insert_or_update_result_blparasite_master`,datTo,getConfigAxios())
                    .then((res)=>{
                        vm.$buefy.toast.open({
                            duration: 1200,
                            message: `${res.data.msg}`,
                            position: 'is-bottom',
                            type: 'is-success'
                        })
                         vm.$emit('closeWithDataChange')
                    })
                    .catch((err)=>{
                        vm.$buefy.toast.open({
                            duration: 1200,
                            message: `${err.response}`,
                            position: 'is-bottom',
                            type: 'is-danger'
                        })
                    })



                }
       },
       addNewDataRes(){
          this.dataAddNewArr.push({"id": genUUID(5) ,"val" :  ""})
       },
 
       close(){
        this.$emit('close')
       },
       deleteDataNew(_id){
            const member =  this.dataAddNewArr.find(dat=>{
                    return dat.id === _id
                })
                const memberIndex = this.dataAddNewArr.indexOf(member)
                this.dataAddNewArr.splice(memberIndex,1)
       }
    },
    data(){
        return{
            isFullScreenSearching : false,
            dataAddNewArr:[], // {"id": "" : "val" :  ""}
        }
    }
}
</script>